import { createRoutine } from "redux-saga-routines";

export const removeDeviceRoutine = createRoutine('REMOVE_DEVICE');
export const logoutOnDeletedDevice = createRoutine('LOGOUT_ON_DELETED_DEVICE');